import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ShoppingCart from '../../components/molecules/ShoppingCart';
import { ViewRoot, ViewContent, ViewContentCenter, ViewSidebar } from '../../layout/Main/styled';
import { dynamicCustomEventTracking } from '../../lib/gtm';
import QuickAccessForm from '../../components/molecules/QuickAccessForm';
import { EcommerceEventTrackingInstance } from '../../lib/gtm/EcommerceEventTracking';
import { RootState } from '../../store';
import { useCookies } from 'react-cookie';
import { useMeSoftLoginMutation } from '../../services/me.service';
import SoftLoginForm from '../../components/molecules/SoftLoginForm';
import PageLoading from '../../components/molecules/Loading';

const QuickAccess = () => {
  const [cookies] = useCookies(['oya_oyana_access_token']);
  const { product } = useSelector((state: RootState) => state);
  const [softLogin, setSoftLogin] = useState(false);
  const [getMeSoftLogin, { isLoading, isError, data }] = useMeSoftLoginMutation();
  const onChange = (logedIn: boolean) => {
    setSoftLogin(logedIn);
  };

  useEffect(() => {
    EcommerceEventTrackingInstance.sendBeginCheckoutEvent({
      productId: product.id || '',
      productName: product.name || '',
      productPrice: product.price || 0
    });
    dynamicCustomEventTracking.send({ dynamicEventName: 'journey_quick_access_ag' });
  }, []);

  useEffect(() => {
    if (cookies.oya_oyana_access_token) {
      getMeSoftLogin({ token: cookies.oya_oyana_access_token });
    }
  }, [cookies.oya_oyana_access_token]);

  useEffect(() => {
    if (data) {
      setSoftLogin(true);
    }
  }, [data]);

  return (
    <>
      <ViewRoot>
        <ViewContent className="ViewContent">
          <ViewContentCenter>
            {isLoading && <PageLoading />}

            {data && softLogin && <SoftLoginForm onChange={onChange} user={data} token={cookies.oya_oyana_access_token} />}

            {!isLoading && (isError || !softLogin) && (
              <QuickAccessForm onChange={onChange} canGoBack={!!cookies.oya_oyana_access_token} />
            )}

            {/* <ManagerStepper /> */}
          </ViewContentCenter>
        </ViewContent>
        <ViewSidebar component="aside" className="ViewSidebar">
          <ShoppingCart />
        </ViewSidebar>
      </ViewRoot>
    </>
  );
};

export default QuickAccess;
